import {
  MarketingSection,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";

export default function MasteringFinish() {
  return (
    <MarketingSection
      className="bg-white"
      innerClassName="grid grid-cols-[minmax(0,1fr)_minmax(320px,0.75fr)] items-center gap-[clamp(55px,8vw,115px)] max-[680px]:grid-cols-1"
    >
      <div>
        <SectionKicker>Why mastering matters</SectionKicker>
        <SectionTitle>The finishing touch for your final mix.</SectionTitle>
      </div>
      <div className="font-open-sans text-[19px] leading-[1.7] text-marketing-muted">
        <p>
          Mastering brings balance, clarity, and consistent loudness to your
          final mix so it translates well across headphones, phone speakers, car
          stereos, and club systems.
        </p>
        <p className="mt-[18px]">
          Lutely gives your tracks the professional polish they need so they’re
          ready to release.
        </p>
      </div>
    </MarketingSection>
  );
}
